var _style, _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-1.5 -1.5 125 97",
    style: {
      enableBackground: "new 0 0 122 94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C1E27;stroke:#FFFFFF;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#1C1E27;stroke:#FFFFFF;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8_",
    className: "st0",
    points: "103.3,94 27.9,85.9 0,27.8 58.1,0 122,40.9 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    className: "st1",
    d: "M19.9,60.6c0,0,4.5,5.2,10.5,5.2c2.7,0,4.8-1.1,4.8-3.5c0-5-18.6-4.9-18.6-16.3    c0-7,6.3-10.3,13.7-10.3c4.8,0,12.4,1.6,12.4,7.3v3.7h-7.7V45c0-1.7-2.5-2.5-4.4-2.5c-3.1,0-5.2,1.1-5.2,3.2    c0,5.5,18.7,4.4,18.7,16.1c0,6.6-5.9,10.8-13.5,10.8c-9.7,0-14.6-6.3-14.6-6.3L19.9,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    className: "st1",
    d: "M67.8,35.8c10.8,0,19.3,7.7,19.3,18.4c0,10.8-8.6,18.4-19.3,18.4c-10.7,0-19.3-7.6-19.3-18.4    C48.6,43.4,57.1,35.8,67.8,35.8z M67.8,65.2c5.7,0,10.5-4.4,10.5-11c0-6.5-4.8-11-10.5-11c-5.7,0-10.4,4.5-10.4,11    C57.4,60.8,62.1,65.2,67.8,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st1",
    d: "M94.3,31.8c0-1-0.6-1.5-1.5-1.5H90v-7.5h8.3c3.2,0,4.7,1.4,4.7,4.7v35.4c0,1,0.6,1.5,1.5,1.5    h2.7v7.4H99c-3.3,0-4.7-1.4-4.7-4.7V31.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolLogo);
export default __webpack_public_path__ + "static/media/sol_logo.136ea98cb026b57856f62c7e60b82047.svg";
export { ForwardRef as ReactComponent };